import { render, staticRenderFns } from "./leafColorful.vue?vue&type=template&id=0ab3b12c"
import script from "./leafColorful.vue?vue&type=script&lang=js"
export * from "./leafColorful.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports